<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">{{ this.$route.meta.title }}</div>
        <utility-list-component :utilityType="'utilityAll'"></utility-list-component>
      </div>
    </div>
  </div>
</template>
<script>
import UtilityListComponent from "@/components/utility/UtilityListComponent.vue";

export default {
    name: "Utility",
    mixins: [],
    components: {UtilityListComponent},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
